import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { Galleria } from 'primereact/galleria';
import { Skeleton } from 'primereact/skeleton';
import moment from 'moment';

moment.locale('pt-br');

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const number = new Intl.NumberFormat('pt-BR', { style: 'decimal', maximumFractionDigits: 2 });

const TIPO_NEGOCIO_LABELS = { Venda: 'Revenda', Aluguel: 'Locação' };

/**
 * Modal de detalhe de um imóvel (Revenda e Locação, Mapbox). Recebe o objeto do
 * imóvel já carregado (via crawler getEmpreendimento) e o exibe em PrimeReact
 * Dialog + TabView, com galeria de fotos. Port de MapaRevendaLocacao/ModalEmpreendimentos.
 */
class ImovelModal extends Component {
    galleriaItemTemplate = (src) => (
        <img
            src={src}
            alt="Foto do imóvel"
            style={{ width: '100%', maxHeight: 380, objectFit: 'cover', display: 'block' }}
        />
    );

    galleriaThumbTemplate = (src) => (
        <img src={src} alt="miniatura" style={{ width: 60, height: 45, objectFit: 'cover' }} />
    );

    precoMetro = (preco, area) => {
        const p = Number(preco);
        const a = Number(area);
        if (!p || !a) return '-';
        return currency.format(p / a);
    };

    renderBody() {
        const e = this.props.empreendimento;

        if (this.props.loading || !e) {
            return (
                <div>
                    <Skeleton height="240px" className="mb-3" />
                    <Skeleton width="60%" className="mb-2" />
                    <Skeleton width="40%" className="mb-2" />
                    <Skeleton width="80%" />
                </div>
            );
        }

        const fotos = Array.isArray(e.fotos) ? e.fotos : [];

        return (
            <div>
                <div className="mrl-mapbox-imovel-header">
                    <h3 className="mb-1">
                        <i className="far fa-building" /> {e.titulo}
                    </h3>
                    <small className="text-muted d-block">{e.tipo}</small>
                    <span className="badge badge-success mt-1">
                        {TIPO_NEGOCIO_LABELS[e.tipo_negocio] || e.tipo_negocio}
                    </span>
                    {e.updatedAt && (
                        <div className="mt-1">
                            <strong>Atualizado em:</strong> {moment(e.updatedAt).format('DD/MM/YYYY HH:mm')}
                        </div>
                    )}
                </div>

                <TabView>
                    <TabPanel header="Imóvel">
                        {fotos.length > 0 && (
                            <Galleria
                                value={fotos}
                                numVisible={5}
                                item={this.galleriaItemTemplate}
                                thumbnail={this.galleriaThumbTemplate}
                                showThumbnails={fotos.length > 1}
                                showIndicators={fotos.length > 1}
                                style={{ maxWidth: '100%', marginBottom: 16 }}
                            />
                        )}

                        <p className="mb-2">
                            <i className="nc-icon nc-pin-3" />{' '}
                            {[e.logradouro, e.numero, e.bairro].filter(Boolean).join(', ')}
                            {e.cidade ? ` — ${e.cidade}` : ''}{e.estado ? `/${e.estado}` : ''}
                        </p>
                        <hr />
                        <div><strong>Preço:</strong> {currency.format(e.preco || 0)}</div>
                        <div><strong>Área Total:</strong> {number.format(e.area_total || 0)} m²</div>
                        <div><strong>Preço m² Total:</strong> {this.precoMetro(e.preco, e.area_total)}</div>
                        <div><strong>Área Útil:</strong> {number.format(e.area_util || 0)} m²</div>
                        <div><strong>Preço m² Útil:</strong> {this.precoMetro(e.preco, e.area_util)}</div>
                    </TabPanel>

                    <TabPanel header="Ficha">
                        <div><strong>Anunciante:</strong> {e.anunciante || '-'}</div>
                        {e.anuncioUrl && (
                            <div>
                                <strong>Anúncio:</strong>{' '}
                                <a href={e.anuncioUrl} target="_blank" rel="noopener noreferrer">
                                    {e.anuncioUrl}
                                </a>
                            </div>
                        )}
                        <div><strong>Quartos:</strong> {e.quartos ?? 0}</div>
                        <div><strong>Suítes:</strong> {e.suites ?? 0}</div>
                        <div><strong>Vagas:</strong> {e.parkingSpaces ?? 0}</div>
                        <div><strong>IPTU:</strong> {e.iptu ?? e.itpu ?? 0}</div>
                        <div><strong>Condomínio:</strong> {currency.format(e.condominio || 0)}</div>
                        {e.descricao && (
                            <>
                                <hr />
                                <strong>Descrição:</strong>
                                <p dangerouslySetInnerHTML={{ __html: e.descricao }} />
                            </>
                        )}
                    </TabPanel>
                </TabView>
            </div>
        );
    }

    render() {
        return (
            <Dialog
                header="Detalhes do Imóvel"
                visible={this.props.show}
                style={{ width: '60vw', maxWidth: 900 }}
                breakpoints={{ '960px': '90vw' }}
                onHide={this.props.onHide}
                dismissableMask
            >
                {this.renderBody()}
            </Dialog>
        );
    }
}

export default ImovelModal;
